import CssBaseLine from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import SignUpTable from './SignUpTable';

const SignUp = () => {  
  return (
       <> <CssBaseLine />
        <Grid container spacing={3} style={{ flex: '1', width: '100%' }}>
          <Container>
            <Grid item xs={12} md={4} style={{ paddingTop: '40px',}}> 
              <SignUpTable /> 
            </Grid>
          </Container>
        </Grid> 
    </>
  );
}

export default SignUp;